ApiAjax = require 'app/scripts/network/api-ajax'
Promise = require 'bluebird'
f = require 'effing'
_ = require 'underscore'
assert = require 'app/scripts/lib/assert'
ApiError = require 'app/scripts/network/api-error'

module.exports = (args) ->
  assert 'success' !of args && 'error' !of args, "This is promise country!"

  Promise.fromNode f(ApiAjax, args)
  .catch ([xhr]) ->
    Promise.reject ApiError.fromResponse(xhr.status, xhr.responseText)
  .get 0
